var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleTagManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2469.7 2469.8",
    style: {
      enableBackground: "new 0 0 2469.7 2469.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#8AB4F8;}\r\n\t.st1{fill:#4285F4;}\r\n\t.st2{fill:#246FDB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1449.8,2376L1021,1946.7l921.1-930.5l436.7,436.6L1449.8,2376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1452.9,527.1L1016.3,90.4L90.5,1016.2c-120.6,120.5-120.7,315.8-0.2,436.4c0.1,0.1,0.2,0.2,0.2,0.2 l925.8,925.8l428.3-430.3L745,1235.1L1452.9,527.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2378.7,1016.2L1452.9,90.4c-120.6-120.6-316.1-120.6-436.7,0c-120.6,120.6-120.6,316.1,0,436.6l926.3,925.8 c120.6,120.6,316.1,120.6,436.6,0c120.6-120.6,120.6-316.1,0-436.6L2378.7,1016.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1231.2,
    cy: 2163.9,
    r: 306
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTagManager);
export default __webpack_public_path__ + "static/media/google-tag-manager.10428acf8c0a76f675f83d2422df08f0.svg";
export { ForwardRef as ReactComponent };